import axios from "axios";

const KEY = "vishu_admin_token";
let onExpired = () => {};

export const getAdminToken = () => sessionStorage.getItem(KEY);
export const setAdminToken = (t) => (t ? sessionStorage.setItem(KEY, t) : sessionStorage.removeItem(KEY));
export const onAdminSessionExpired = (fn) => { onExpired = fn; };

const isAdminUrl = (url = "") => url.includes("/api/admin/") && !url.includes("/api/admin/login");

axios.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token && isAdminUrl(config.url)) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && isAdminUrl(err.config?.url)) { setAdminToken(null); onExpired(); }
    return Promise.reject(err);
  }
);
